import React, { useState, useEffect } from 'react'

import { logout } from '../../../services/auth'
import Botao from '../../Mantine/Botao'
import Checkbox from '../../Mantine/Checkbox'
import Modal from '../../Mantine/Modal'

import * as S from './styles'

export default function ModalTermosCondicoes({
  opened,
  onClose,
  onConfirmar,
  onVerMaisTarde
}) {
  const [aceitarTermos, setAceitarTermos] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 769)
    }

    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (opened) {
        logout()
      }
    }

    if (opened) {
      window.addEventListener('beforeunload', handleBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [opened])

  const pdfZoom = isMobile ? 60 : 87

  return (
    <Modal
      opened={opened}
      close={onClose}
      withCloseButton={false}
      showActionsModal={false}
      useWhiteTheme
      minHeight="max-content"
      closeOnClickOutside={false}
    >
      <S.TermosContainer>
        <div>
          <h4>📢 Regularização Contratual – Termo de Prestação de Serviços</h4>
          <br />
          <strong>Prezado cliente,</strong>
          <p>
            Identificamos que seu cadastro está desatualizado em relação ao
            Termo de Prestação de Serviços da VirtuEyes.
          </p>
          <p>
            Para garantir a continuidade dos serviços contratados, trazendo
            segurança jurídica e sem riscos de interrupções, é necessário
            realizar a regularização contratual por meio do aceite ao Termo de
            Adesão.
          </p>
          <p>
            ⚠️ O aceite é obrigatório e deve ser realizado diretamente nesta
            plataforma para que os serviços permaneçam ativos e em conformidade
            contratual.
          </p>
          <p>
            Visualize o Termo de Adesão abaixo e clique em "Declaro que li e
            aceito os termos" para confirmar sua concordância.
          </p>
        </div>

        <S.ConteudoTermos>
          <iframe
            src={`/documents/Termo-Adesao-Veye.pdf#toolbar=0&navpanes=0&scrollbar=1&zoom=${pdfZoom}`}
            width="100%"
            height="100%"
            title="Termos e Condições"
            style={{
              border: 'none',
              zoom: '125%' //* Compensa o zoom 80% do body
            }}
          />
        </S.ConteudoTermos>
        <S.AceitarTermos>
          <Checkbox
            label="Declaro que li e aceito os termos."
            checked={aceitarTermos}
            onChange={(event) => setAceitarTermos(event.currentTarget.checked)}
          />
        </S.AceitarTermos>
        <S.BotoesContainer>
          <Botao
            label="Ver mais tarde"
            variant="outline"
            onClick={onVerMaisTarde}
          />
          <Botao
            label="Confirmar"
            variant="primary"
            disabled={!aceitarTermos}
            onClick={onConfirmar}
          />
        </S.BotoesContainer>
      </S.TermosContainer>
    </Modal>
  )
}
